import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getUser } from '../state/user/actions'

const useInitUser = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getUser())
  }, [])
}

export default useInitUser
